export const defaultColumns = [
  {label: 'Tipo de integração', value: 'displayName'},
  {label: 'Habilitada', value: 'active'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]
